import { IDomEditor, IDropPanelMenu, Boot } from '@wangeditor/editor';

class MyDropPanelMenu implements IDropPanelMenu {
  title: string;
  tag: string;
  showDropPanel: boolean;
  // TS 语法
  // class MyDropPanelMenu {                           // JS 语法

  constructor() {
    this.title = '选择插入参数';
    // this.iconSvg = '<svg >...</svg>'
    this.tag = 'button';
    this.showDropPanel = true;
  }

  // 菜单是否需要激活（如选中加粗文本，“加粗”菜单会激活），用不到则返回 false
  isActive(editor: IDomEditor): boolean {
    // TS 语法
    // isActive(editor) {                      // JS 语法
    return false;
  }

  // 获取菜单执行时的 value ，用不到则返回空 字符串或 false
  getValue(editor: IDomEditor): string | boolean {
    // TS 语法
    // getValue(editor) {                               // JS 语法
    return '';
  }

  // 菜单是否需要禁用（如选中 H1 ，“引用”菜单被禁用），用不到则返回 false
  isDisabled(editor: IDomEditor): boolean {
    // TS 语法
    // isDisabled(editor) {                     // JS 语法
    return false;
  }

  // 点击菜单时触发的函数
  exec(editor: IDomEditor, value: string | boolean) {
    // TS 语法
    // exec(editor, value) {                              // JS 语法
    // DropPanel menu ，这个函数不用写，空着即可
  }

  // 定义 DropPanel 内部的 DOM Element
  getPanelContentElem(editor: IDomEditor): HTMLElement {
    const variableMap = {
      医院名: '#{hospitalName}',
      当天日期: '#{nowDate}',
      宠主名: '#{petOwnerName}',
      宠主号码: '#{petOwnerPhoneNumber}',
      宠物昵称: '#{petNickname}',
      宠物种类: '#{petSpecies}',
      宠物品种: '#{petBreeds}',
      宠物性别: '#{petGender}',
      宠物体重: '#{petWeight}',
      宠物年龄: '#{petAge}',
      病历号: '#{medicalRecordNo}',
      初步诊断: '#{primaryDiagnosis}',
    };
    const cities = [
      '医院名',
      '当天日期',
      '宠主名',
      '宠主号码',
      '宠物昵称',
      '宠物种类',
      '宠物品种',
      '宠物性别',
      '宠物体重',
      '宠物年龄',
      '病历号',
      '初步诊断',
    ];
    const ul = document.createElement('ul');
    ul.setAttribute('style', 'list-style-type: none; ');

    cities.forEach((name) => {
      const li = document.createElement('li');
      li.setAttribute('style', 'margin-bottom:10px;cursor: pointer;heigth:20px;line-height:20px;');
      li.textContent = name;
      li.addEventListener('click', () => {
        editor.insertText(variableMap[name]);
        editor.insertText('');
      });
      ul.appendChild(li);
    });

    return ul; // 返回 DOM Element 类型
  }
}

//自定义富文本菜单功能，插入变量
const menu1Conf = {
  key: 'menu1', // 定义 menu key ：要保证唯一、不重复（重要）
  factory() {
    return new MyDropPanelMenu(); // 把 `YourMenuClass` 替换为你菜单的 class
  },
};

export const initPlug = () => {
  Boot.registerMenu(menu1Conf);
};
